<template>
  <div>
    <vxe-grid
      ref="table"
      row-id="custBizTeamSetCode"
      round
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(opt, index) in tableOpts">
                <el-dropdown-item
                  v-if="opt.authority ? opt.authority(row) : false"
                  :key="index"
                  :icon="opt.icon"
                  :command="{ opt, row }"
                  :divided="opt.divided"
                >
                  {{ opt.text }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayLogo="{ row: { bigImageUrl } }">
        <div class="d-flex">
          <el-image
            :src="bigImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[bigImageUrl || '/image/static/img/nopic.jpg']"
            style="width: 90px; height: 90px"
            fit="contain"
          />
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div>{{ row.custNo }}</div>
        <el-tag
          size="mini"
          :type="
            row.custStatus === 'N' || row.custStatus === 'B'
              ? 'danger'
              : row.custStatus === 'P'
              ? 'warning'
              : row.custStatus === 'P'
              ? 'success'
              : ''
          "
        >
          {{ row.v_custStatus }}
        </el-tag>
      </template>
      <template v-slot:displayName="{ row }">
        <div>{{ row.custShortName }}</div>
        <div>{{ row.custName }}</div>
      </template>

      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createDate }}</div>
      </template>
      <template v-slot:displayCategory="{ row }">
        <div
          v-if="row.custCategoryNameList && !!row.custCategoryNameList.length"
        >
          <el-tag
            size="mini"
            class="mr-1"
            v-for="(category, index) in row.custCategoryNameList"
            :key="index"
          >
            {{ category }}
          </el-tag>
        </div>
      </template>
      <template v-slot:custApprovalNode="{ row }">
        <el-tag
          size="mini"
          :type="
            row.custApprovalNode === '1'
              ? 'primary'
              : row.custApprovalNode === '2'
              ? 'success'
              : 'warning'
          "
        >
          {{ row.custApprovalNodeName }}
        </el-tag>
      </template>
      <template v-slot:approvalStatus="{ row }">
        <el-tag
          v-if="row.custApprovalNode === '1'"
          size="mini"
          :type="
            row.managerApprovalStatus === 'P'
              ? 'primary'
              : row.managerApprovalStatus === 'Y'
              ? 'success'
              : 'warning'
          "
        >
          {{ row.managerApprovalStatusName }}
        </el-tag>
        <el-tag
          v-if="row.custApprovalNode === '2'"
          size="mini"
          :type="
            row.ceoApprovalStatus === 'P'
              ? 'primary'
              : row.ceoApprovalStatus === 'Y'
              ? 'success'
              : 'warning'
          "
        >
          {{ row.ceoApprovalStatusName }}
        </el-tag>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableOpts from './table-opts'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      formData: {},
      tableColumns: tableColumns(this),
    }
  },

  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },

  methods: {
    optCommand({ opt, row }) {
      const { menuType } = opt

      switch (menuType) {
        case 'detail':
        case 'managerApproval':
        case 'ceoApproval':
          this.$emit('openEditFormDialog', { type: menuType, row })
          break
      }
    },
  },
}
</script>
